var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{attrs:{"icon":[_vm.type, _vm.icon],"size":_vm.size,"border":_vm.border,"flip":_vm.flip,"rotation":_vm.rotation,"inverse":_vm.inverse,"color":_vm.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }